import { ServerConfiguration } from "./servers.js";
import { configureAuthMethods } from "./auth/auth.js";
export function createConfiguration(conf) {
    const configuration = {
        baseServer: new ServerConfiguration(conf.baseUrl || "", {}),
        middleware: conf.middleware || [],
        authMethods: configureAuthMethods(conf.authMethods),
        timeout: conf.timeout,
        retries: conf.retries ?? 1,
        retryNonIdempotent: conf.retryNonIdempotent,
        signal: conf.signal
    };
    return configuration;
}
